module.exports = __webpack_public_path__ + "img/pay_state_duty.e84cabcb.jpg";